export default __webpack_public_path__ + "static/media/codigo-conduta.b1d93d20.pdf";